import { AccordionBody, AccordionHeader, AccordionItem } from "../../Accordion";
import RadioCard from "../../RadioCard";
import ValidatedField from "../../form/ValidatedField";
import {
  RevisorsSectionProps,
  scrollToRefIfNotInView,
} from "../RevisorsErklaering";

export default function RevisorsHandling3(props: RevisorsSectionProps) {
  const { isCompleteHelpers, formikProps, refs, texts, locked } = props;
  const { revisors_handling_3 } = texts;
  const { values, errors, touched } = formikProps;
  return (
    <AccordionItem value="Handling3">
      <AccordionHeader
        sectionStarted={!!values.revisors_handling_3_question}
        sectionComplete={isCompleteHelpers.revisors_handling_3_complete}
        ref={refs.handling_3_ref}
        onClick={() => {
          scrollToRefIfNotInView(refs.handling_2_ref);
        }}
      >
        {revisors_handling_3.title}
      </AccordionHeader>
      <AccordionBody>
        <fieldset disabled={locked}>
          <legend className="h5 fw-normal mb-4 lh-base">
            {revisors_handling_3.description}
          </legend>
          <div className="vstack gap-3" role="group">
            <RadioCard
              name={revisors_handling_3.revisors_handling_3_question.id}
              value={
                revisors_handling_3.revisors_handling_3_question
                  .revisors_handling_3_question_alt_1.value
              }
              id={
                revisors_handling_3.revisors_handling_3_question
                  .revisors_handling_3_question_alt_1.value
              }
              text={
                revisors_handling_3.revisors_handling_3_question
                  .revisors_handling_3_question_alt_1.label
              }
            ></RadioCard>
            <RadioCard
              name={revisors_handling_3.revisors_handling_3_question.id}
              value={
                revisors_handling_3.revisors_handling_3_question
                  .revisors_handling_3_question_alt_2.value
              }
              id={
                revisors_handling_3.revisors_handling_3_question
                  .revisors_handling_3_question_alt_2.value
              }
              text={
                revisors_handling_3.revisors_handling_3_question
                  .revisors_handling_3_question_alt_2.label
              }
            >
              <ValidatedField
                autoComplete="off"
                type="text"
                placeholder="Bogføringssystem"
                name={
                  revisors_handling_3
                    .revisors_handling_3_alt_2_bogfoeringssystem.id
                }
                touched={touched.revisors_handling_3_alt_2_bogfoeringssystem}
                error={errors.revisors_handling_3_alt_2_bogfoeringssystem}
              />
            </RadioCard>
          </div>
        </fieldset>
      </AccordionBody>
    </AccordionItem>
  );
}
